import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Paper, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { useHistory } from 'react-router-dom';
import { routerTreeMap } from '../../../../constants/NavigationTree';

const useStyles = makeStyles(() => ({
  container: {
    height: 52,
    backgroundColor: (props) => (props.middle ? '' : '#f1f1f1'),
    display: (props) => (props.middle ? 'flex' : ''),
    justifyContent: (props) => (props.middle ? 'center' : ''),
    marginBottom: (props) => (props.middle ? '30px' : ''),
  },
  button: {
    marginTop: '5px',
    marginLeft: '6px',
    '& .MuiButton-label': {
      justifyContent: 'left',
    },
  },
}));

const BackButton = ({ ...props }) => {
  const { middle, pathname } = props;
  const [routePrevData, setRoutePrevData] = useState({});
  const classes = useStyles({ middle });
  const history = useHistory();

  useEffect(() => {
    if (pathname) setRoutePrevData(routerTreeMap.get(pathname));
  }, [pathname]);

  const onClickBack = () => {
    if (routePrevData?.prevRoute) history.push(routePrevData?.prevRoute);
    else history.goBack();
  };

  return (
    <Paper elevation={0} className={classes.container}>
      <Button
        className={classes.button}
        variant="text"
        startIcon={<ArrowBackIosIcon />}
        onClick={onClickBack}
      >
        Volver a{' '}
        {routePrevData?.titlePrevRoute ? routePrevData.titlePrevRoute : ''}
      </Button>
    </Paper>
  );
};

BackButton.propTypes = {
  middle: PropTypes.bool,
  pathname: PropTypes.string,
};

export default BackButton;
